import React from 'react';
import { alpha, Box } from '@mui/material';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import { MapIconContainer } from '../MapIconContainer';
import { useShadowStyle } from '../../hooks/useShadowStyle';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { SpotDraft } from 'store/slices/spotDrafts';

interface MarkerDraftProps {
    draft: SpotDraft;
}

const MarkerDraft = ({ draft }: MarkerDraftProps) => {
    const theme = useTheme();
    const shadowStyle = useShadowStyle();

    return (
        <Box
            sx={{
                'position': 'relative',
                '&:hover > .hover-content': {
                    display: 'block',
                },
            }}
        >
            <MapIconContainer>
                <EditLocationAltIcon
                    sx={{
                        ...shadowStyle,
                        fill: theme.palette.warning.main,
                    }}
                    fontSize="large"
                />
            </MapIconContainer>
            <Box
                className="hover-content"
                sx={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'none',
                }}
            >
                <Box
                    sx={{
                        minWidth: '160px',
                        maxWidth: '240px',
                        py: 0.5,
                        px: 2,
                        backgroundColor: alpha(theme.palette.warning.main, 0.85),
                        borderRadius: theme.shape.borderRadius,
                        boxShadow: theme.defaultShadow(),
                        color: theme.palette.warning.contrastText,
                    }}
                >
                    <Typography variant="body2" fontWeight={600}>
                        {draft.name || 'Unnamed draft'}
                    </Typography>
                    <Typography variant="caption">
                        Draft · step {draft.step} of 4
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default MarkerDraft;
